/**
 * @file UseCasesSection.tsx
 * @description Enterprise application scenarios section on the home page.
 */

/**
 * UseCasesSection component outlines representative use cases powered by Ultimind.
 */
export function UseCasesSection() {
  const cases = [
    {
      title: 'Wealth management KYC',
      body:
        'Verdant.AI automates source-of-wealth analysis by reading payslips, tax returns, portfolios, and property records to generate compliant SoW reports.',
      tag: 'Financial services',
    },
    {
      title: 'Smart destinations & resorts',
      body:
        'Multi-agent assistants coordinate marketing, bookings, and on-site operations for resorts and cultural tourism, improving guest experience end to end.',
      tag: 'Culture & tourism',
    },
    {
      title: 'Intelligent operations',
      body:
        'From manufacturing workshops to government dashboards, agents connect forms, workflows, and data silos into adaptive automation.',
      tag: 'Government & manufacturing',
    },
  ]

  return (
    <section className="bg-slate-950">
      <div className="mx-auto max-w-6xl px-4 pb-14 md:px-6 md:pb-20">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div>
            <h2 className="text-2xl font-semibold tracking-tight text-slate-50 md:text-3xl">
              Proven in demanding enterprise scenarios
            </h2>
            <p className="mt-3 max-w-xl text-sm text-slate-300 md:text-base">
              Ultimind works with leading institutions across government,
              healthcare, manufacturing, and tourism to unlock new productivity
              with AI agents.
            </p>
          </div>
          <a
            href="#/cases"
            className="text-sm font-semibold text-sky-300 hover:text-sky-200"
          >
            View detailed case studies →
          </a>
        </div>
        <div className="mt-8 grid gap-6 md:grid-cols-3">
          {cases.map((item) => (
            <article
              key={item.title}
              className="flex h-full flex-col rounded-2xl border border-slate-800 bg-slate-900/60 p-5"
            >
              <span className="inline-flex w-fit rounded-full bg-sky-500/10 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-sky-300">
                {item.tag}
              </span>
              <h3 className="mt-3 text-sm font-semibold text-slate-50 md:text-base">
                {item.title}
              </h3>
              <p className="mt-2 text-xs text-slate-300 md:text-sm">
                {item.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
